export default __webpack_public_path__ + "static/media/PWA-Text-Editor.497c980c.png";